<template>
  <custome-Dialog
    :dialog-visible.sync="dialogVisible"
    :confirm-text="confirmText"
    :title="title"
    width="30%"
    :cancel-disable="cancelDisable"
    :confirm-disable="false"
    @confirm="confirm"
    @close="close"
  >
    <div class="content">
      <el-form
        v-if="step === 1"
        ref="createForm"
        :model="createForm"
        :rules="creatRules"
        label-width="100px"
      >
        <el-form-item
          label="抵用券券号"
          prop="couponNumber"
        >
          <el-input v-model="createForm.couponNumber" />
        </el-form-item>
      </el-form>
      <div
        v-else
        class="wx-info"
      >
        <div class="item">
          <span>券号码:</span>
          <span>{{ couponInfo.couponNumber }}</span>
        </div>
        <div class="item">
          <span>机构名称:</span>
          <span>{{ couponInfo.buyAgencyName }}</span>
        </div>
      </div>
    </div>
  </custome-Dialog>
</template>
<script>
import customeDialog from '@/components/common/dialog.vue';
import axClient from '@/services';

export default {
  name: 'UsercouponInfo',
  components: { customeDialog },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      title: '使用辅导员抵用券',
      cancelText: '取消',
      step: 1,
      createForm: {
        couponNumber: null,
      },
      creatRules: {
        couponNumber: [
          { required: true, message: '请输入辅导员抵用券', trigger: 'blur' },
        ],
      },
      couponInfo: {},
    };
  },
  computed: {
    confirmText() {
      return this.step === 1 ? '下一步' : '使用';
    },
    cancelDisable() {
      return this.step === 2;
    },
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.$nextTick(() => {
          this.createForm.couponNumber = '';
        });
      }
    },
  },
  methods: {
    close() {
      if (this.step !== 1) {
        this.step = 1;
        return;
      }
      this.$emit('update:dialogVisible', false);
    },
    confirm() {
      if (this.step === 2) {
        this.$emit('getCouponInfo', this.couponInfo);
        this.$emit('update:dialogVisible', false);
        return;
      }
      this.$refs.createForm.validate(async (valid) => {
        if (valid) {
          const data = await axClient.points.counselorCouponQuery({ couponNumber: this.createForm.couponNumber });
          if (!data) return;
          const {
            id, couponNumber, buyAgencyName,
          } = data;
          this.couponInfo = {
            id, couponNumber, buyAgencyName,
          };
          this.step = 2;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  min-height: 200px;
  .wx-info {
    padding: 0 0 0 0;
    text-align: left;
    .item {
      margin-bottom: 15px;
      span {
        font-size: 12px;
        color: $--base-color-black;
        &:last-child {
          padding-left: 8px;
        }
      }
    }
  }
}

</style>
